<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink style="display: flex; align-items: center; gap: 10px;">
        <p class="mt-3 mb-0">{{ userName }}</p>
        <div class="c-avatar ml-2">
          <img
            :src="userPhoto || 'img/avatars/icon_user.png'"
            class="c-avatar-img"
          />
        </div>
      </CHeaderNavLink>
    </template>
    <!--
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Account</strong>
    </CDropdownHeader>
    
    <CDropdownItem>
      <CIcon name="cil-bell"/> Updates
      <CBadge color="info" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-envelope-open" /> Messages
      <CBadge color="success" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-task" /> Tasks
      <CBadge color="danger" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-comment-square" /> Comments
      <CBadge color="warning" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> 
    -->
       
    <!--
    <CDropdownItem>
      <CIcon name="cil-dollar" /> Payments
      <CBadge color="secondary" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-file" /> Projects
      <CBadge color="primary" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem>
      <CIcon name="cil-shield-alt" /> Lock Account
    </CDropdownItem> 
    -->
    <CDropdownItem @click="logout()">
      <CIcon name="cil-lock-locked" /> Cerrar Sessión
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import axios from 'axios'
export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      itemsCount: 42,
      userEmail: '',
      userName: '',
      userPhoto: null,
      isAdmin: false,
    }
  },
  methods:{
    logout(){
      let self = this;
      axios.post(this.$apiAdress + '/api/logout?token=' + localStorage.getItem("api_token"),{})
      .then(function (response) {
        localStorage.setItem('roles', '');
        localStorage.setItem('email', '');
        localStorage.setItem('name', '');
        localStorage.setItem('id', '');
        localStorage.removeItem('photo_url');
        localStorage.removeItem("course");
        self.$router.push({ path: '/login' });
      }).catch(function (error) {
         if(error.response.status == 401){
            self.Loading = false;
            self.$router.push({ path: "/login" });
            localStorage.clear();
          }
      });
    },
    goUsers(){
      this.$router.push({path: '/users'});
    },
    goSettings(){
      this.$router.push({path: 'settings'});
    }
  },

  mounted: function(){
    let self = this;

    self.userEmail = localStorage.getItem('email');
    self.userName  = localStorage.getItem('name');
    self.userPhoto = localStorage.getItem('photo_url') || null;

    if (localStorage.getItem('roles') == 'user,admin') {
      self.isAdmin = true;
    }

    // Sync photo from API to keep it fresh
    axios.get(this.$apiAdress + '/api/user/profile?token=' + localStorage.getItem('api_token'))
      .then(function (response) {
        if (response.data && response.data.photo) {
          const fullUrl = self.$apiAdress + response.data.photo;
          self.userPhoto = fullUrl;
          localStorage.setItem('photo_url', fullUrl);
        }
      })
      .catch(function () { /* silent */ });

  }
}
</script>
<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
